import { Button } from '@/shared/ui/button'
import { Icon } from '@/shared/ui/icon'
import { toast } from '@/shared/ui/toast'
import { useApproveDocument, useRevokeApproval } from '../api/approve'

interface ApproveButtonProps {
  documentId: string
  currentVersionNumber: number
  approvedCurrent: boolean
}

// Заказчик согласует последнюю версию или снимает согласование.
export function ApproveButton({
  documentId,
  currentVersionNumber,
  approvedCurrent,
}: ApproveButtonProps) {
  const approve = useApproveDocument(documentId)
  const revoke = useRevokeApproval(documentId)
  const pending = approve.isPending || revoke.isPending

  if (approvedCurrent) {
    return (
      <Button
        variant="ghost"
        size="sm"
        disabled={pending}
        onClick={() =>
          revoke.mutate(undefined, {
            onSuccess: () => toast.success('Согласование снято'),
            onError: () => toast.error('Не удалось снять согласование'),
          })
        }
      >
        Снять согласование
      </Button>
    )
  }

  return (
    <Button
      size="sm"
      disabled={pending}
      onClick={() =>
        approve.mutate(currentVersionNumber, {
          onSuccess: () => toast.success('Документ согласован'),
          onError: () => toast.error('Не удалось согласовать'),
        })
      }
    >
      <Icon name="check-circle" size={16} />
      Согласовать
    </Button>
  )
}
